<template>
  <vs-popup title="Sincronizar Analytics" :active.sync="isActive" @close="close()">
    <div class="d-flex" style="align-items:center; gap:16px; padding:10px;">
      <div style="flex:1">
        <flat-pickr
          :config="flatpickr"
          v-model="startAt"
          name="Período (de)"
          placeholder="Escolha um dia"
          v-validate="'required'"
          style="width:100%; border-radius:6px; padding:8px 10px;"
        />
      </div>

      <div style="flex:1">
        <flat-pickr
          :config="finishAtConfig(flatpickr)"
          v-model="finishAt"
          name="Período (até)"
          placeholder="Escolha um dia"
          v-validate="'required'"
          :disabled="startAt === ''"
          style="width:100%; border-radius:6px; padding:8px 10px;"
        />
      </div>

      <div class="d-flex">
        <vs-checkbox v-model="forceUpdateAnalytics">
          <span>Forçar Atualização</span>
        </vs-checkbox>
      </div>

      <vs-button type="filled" @click="syncAnalytics" :disabled="disableDownload">
        Iniciar
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
import {mapGetters} from 'vuex';
import 'flatpickr/dist/flatpickr.css';
import flatPickr from 'vue-flatpickr-component';
import {Portuguese} from 'flatpickr/dist/l10n/pt.js';

export default {
  name: 'SyncAnalytics',
  components: {flatPickr},
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    tenantName: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['token']),
    disableDownload(){
      return !this.startAt || !this.finishAt || this.startAt === '' || this.finishAt === ''
    }
  },
  data() {
    return {
      startAt: '',
      finishAt: '',
      forceUpdateAnalytics: false,
      flatpickr: {
        enableTime: false,
        noCalendar: false,
        dateFormat: "d/m/Y",
        locale: Portuguese
      }
    }
  },
  methods: {
    close() {
      this.startAt = '';
      this.finishAt = '';
      this.forceUpdateAnalytics = false;
      this.$emit('isActiveFalse');
    },
    finishAtConfig(config) {
      return {
        ...config,
        minDate: this.startAt
      }
    },
    parseDate(dateString, toBrazilian = false) {
      if (!dateString) return dateString;
      const parts = dateString.split(toBrazilian ? '-' : '/');
      return toBrazilian ? `${parts[2]}/${parts[1]}/${parts[0]}` : `${parts[2]}-${parts[1]}-${parts[0]}`;
    },
    syncAnalytics() {
      this.$store.dispatch('syncAnalytics', {
        toDate: this.parseDate(this.finishAt),
        fromDate: this.parseDate(this.startAt),
        forceUpdate: this.forceUpdateAnalytics,
        tenantName: this.tenantName,
        token: this.token
      }).then(response => {
        this.close()
        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: response.data
        });
      }).catch(exception => {
        console.error(exception);
        this.$vs.notify({
          color: 'danger',
          title: 'Erro!',
          text: 'Ocorreu um erro ao realizar a ação! Entre em contato com o time técnico.'
        });
      });
    },
  },
  watch: {
    isActive(value) {
      if (!value) {
        this.startAt = '';
        this.finishAt = '';
        this.forceUpdateAnalytics = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ulOrderSheet {
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin: 10px 0;
    padding: 10px;
    transition: transform 0.2s, box-shadow 0.2s;
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
  }
  span {
    font-weight: bold;
    color: #555;
  }
  a {
    color: #007bff;
    font-weight: bold;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
      color: #0056b3;
    }
  }
}
</style>
